// components/layout/PageTransition.tsx
import { motion } from 'framer-motion';
import React from 'react';

interface PageTransitionProps {
    children: React.ReactNode;
    className?: string;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children, className = '' }) => {
    return (
        <motion.div
            className={`page-container ${className}`}
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 0}}
            transition={{ duration: 0 }}
        >
            {children}
        </motion.div>
    );
};

export default PageTransition;